<div class="app-menu navbar-menu">
    <!-- LOGO -->
    <div class="navbar-brand-box">
        <a routerLink="/" class="logo logo-dark" aria-label="Belatz - Ir al inicio">
            <span class="logo-sm">
                <img src="assets/images/logos/HalconBelatz-sm.webp" alt="" height="70">
            </span>
            <span class="logo-lg">
                <img src="assets/images/logos/Belatz-sm.webp" alt="Belatz" height="30">
            </span>
        </a>
        <a routerLink="/" class="logo logo-light" aria-label="Belatz - Ir al inicio">
            <span class="logo-sm">
                <img src="assets/images/logos/HalconBelatz-sm.webp" alt="" height="70">
            </span>
            <span class="logo-lg">
                <img src="assets/images/logos/Belatz-sm.webp" alt="Belatz" height="25">
            </span>
        </a>
        <button type="button" class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover" aria-label="Colapsar menú lateral">
            <i class="ri-record-circle-line" aria-hidden="true"></i>
        </button>
    </div>

    <div id="scrollbar">
        <div class="container-fluid">

            <!-- ═══════════════════════════════════════
                 COLUMNA 1 – Íconos (Nivel 0 - Padres)
                 ═══════════════════════════════════════ -->
            <div id="two-column-menu">
                <ul class="twocolumn-iconview">
                    <li>
                        <a routerLink="/" class="logo" aria-label="Belatz - Ir al inicio">
                            <img src="assets/images/logos/HalconBelatz-sm.webp" alt="" height="35" aria-hidden="true">
                        </a>
                    </li>
                    @for (section of filteredMenuSections(); track section.id) {
                    <li>
                        <a href="javascript:void(0);" class="nav-icon" [class.active]="activeMenuId() === section.id"
                            [attr.aria-label]="section.label" (click)="selectSection(section.id, $event)"
                            [pTooltip]="section.label" tooltipPosition="right" [showDelay]="200">
                            <i [class]="section.icon" aria-hidden="true"></i>
                        </a>
                    </li>
                    }
                </ul>
            </div>

            <!-- ═══════════════════════════════════════
                 COLUMNA 2 – Hijos Filtrados (Nivel 1+)
                 ═══════════════════════════════════════ -->
            <ul class="navbar-nav" id="navbar-nav" data-simplebar style="margin-top: 10px;"
                [@panelSlide]="layoutService.sidebarCollapsed() ? 'collapsed' : 'expanded'">
                @if (activeMenu(); as section) {
                <li class="menu-title">
                    <span>{{ section.label | uppercase }}</span>
                </li>

                @for (item of section.children; track item.id) {
                <li class="nav-item">
                    @if (hasChildren(item)) {
                    <a href="javascript:void(0);" class="nav-link menu-link has-dropdown"
                        [class.collapsed]="!isOpen(item.id)" (click)="toggleItem(item.id, $event)">
                        <span class="flex-grow-1">{{ item.label }}</span>

                        <!-- FLECHA SVG CON ROTACIÓN INLINE -->
                        <svg class="arrow-icon" aria-hidden="true"
                            [style.transform]="isOpen(item.id) ? 'rotate(90deg)' : 'rotate(0deg)'"
                            [style.transition]="isOpen(item.id) ? 'transform 0.28s ease-out' : 'transform 0.55s ease-in-out'"
                            viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2.5"
                            fill="none" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="9 18 15 12 9 6"></polyline>
                        </svg>
                    </a>

                    <div class="menu-dropdown" [@slideDown]="isOpen(item.id) ? 'open' : 'closed'">
                        <ul class="nav nav-sm flex-column">
                            @for (child of item.children; track child.id) {
                            <li class="nav-item">
                                @if (hasChildren(child)) {
                                <a href="javascript:void(0);" class="nav-link" [class.collapsed]="!isOpen(child.id)"
                                    (click)="toggleItem(child.id, $event)">
                                    <span class="flex-grow-1">{{ child.label }}</span>

                                    <svg class="arrow-icon" aria-hidden="true"
                                        [style.transform]="isOpen(child.id) ? 'rotate(90deg)' : 'rotate(0deg)'"
                                        [style.transition]="isOpen(child.id) ? 'transform 0.28s ease-out' : 'transform 0.55s ease-in-out'"
                                        viewBox="0 0 24 24" width="12" height="12" stroke="currentColor"
                                        stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </a>
                                <div class="menu-dropdown" [@slideDown]="isOpen(child.id) ? 'open' : 'closed'">
                                    <ul class="nav nav-sm flex-column">
                                        @for (grand of child.children; track grand.id) {
                                        <li class="nav-item">
                                            <a [routerLink]="(grand.enConstruccion && !isDev) ? '/en-construccion' : (grand.route ?? '/')"
                                                [queryParams]="(grand.enConstruccion && !isDev) ? { from: grand.route } : null"
                                                routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link">
                                                {{ grand.label }}
                                            </a>
                                        </li>
                                        }
                                    </ul>
                                </div>
                                } @else {
                                <a [routerLink]="(child.enConstruccion && !isDev) ? '/en-construccion' : (child.route ?? '/')"
                                    [queryParams]="(child.enConstruccion && !isDev) ? { from: child.route } : null"
                                    routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" class="nav-link">
                                    {{ child.label }}
                                </a>
                                }
                            </li>
                            }
                        </ul>
                    </div>
                    } @else {
                    <a [routerLink]="(item.enConstruccion && !isDev) ? '/en-construccion' : (item.route ?? '/')"
                        [queryParams]="(item.enConstruccion && !isDev) ? { from: item.route } : null"
                        routerLinkActive="active" class="nav-link menu-link">
                        <span>{{ item.label }}</span>
                    </a>
                    }
                </li>
                }
                }
            </ul>

        </div>
    </div>

    <div class="sidebar-background"></div>
</div>

<div class="vertical-overlay" (click)="layoutService.closeMenu()"></div>